module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAARCAYAAAAG/yacAAAACXBIWXMAAAsSAAALEgHS3X78AAAA+UlEQVQoz42TzY3CMBBGHxF36GDpgN0KtoVcCBIcoAPSwYYOSAfk4IN9gg5CB+kAqACowHuZQcbysvkkS/Z8fp7x38B7T6hivsyBHJhIqAN2zpqLzhkoVMyXY+AAfJNW7awpn5AALTDlvWpnTalQBfzQT1+ZdMrIeABboE5A66GUNoqM3FnTyl4BNoH3mQHjxGrdH33Cg/BRvJGS9YA+Au+oezpG0Aq4AecIAGgVOtBf+wzAWbMHrj2Axllzz4JA9Q/w0Kt5QpLt9AaqnDX3F0gvTlaMdXLW7HTwAslLTr2OdRiIM2mZTZg9/BYAeO+TbVYsulmxKFPeL/IKeNZzRoNqAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_pin_gris.png
// module id = 166
// module chunks = 0